// extracted by mini-css-extract-plugin
export var authorBioEditorialAbout = "D_b8";
export var authorBioEditorialContainer = "D_b7";
export var authorBioEditorialXp = "D_b9";
export var authorBioPageContainer = "D_b6";
export var relatedArticles = "D_x";